import React, { useEffect, useRef, useState } from 'react';
import T from 'prop-types'

import makeAnimated from "react-select/animated";
import { components } from 'react-select';

import SelectExtended from "../Blocks/SelectExtended";
import axios from "axios";

const styles = {
  control: (base, state) => ({
    ...base,
    border: `1px solid #CED4DA`,
    boxShadow: 'none',
    '&:hover': {
      border: `1px solid #CED4DA`,
    },
    fontFamily: "Montserrat",
    fontWeight: 400,
    borderRadius: 0,
    flexWrap: 'nowrap',
    marginTop: '0.75rem',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: 'none',
    '&:hover': { backgroundColor: '#EDEBF0' },
    color: 'black',
    fontWeight: 300,
    fontSize: '12px',
    lineHeight: '14px',
    textTransform: 'capitalize',
    paddingRight: '1rem',
  }),
  valueContainer: (base, state) => ({
    ...base,
    textOverflow: "ellipsis",
    width: '16rem',
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "inline-block",
    marginRight: '4px',
    marginLeft: '2px',
    paddingLeft: '2px',
    paddingBottom: '0.2rem',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    paddingRight: '2px',
  }),
  menu: (base, state) => ({
    ...base,
    textOverflow: "ellipsis",
  }),
  menuList: (base, state) => ({
    ...base,
    maxHeight: '200px',
    textOverflow: 'ellipsis',
    overflowY: 'scroll',
  }),
};

const Option = props => {
  return (
    <div>
      <components.Option {...props}>
        <input
            type="checkbox"
            className='mr-3'
            checked={props.isSelected}
            onChange={() => null}
        />
        <label
            data-bs-toggle={props.label.length > 30 && 'tooltip'}
            style={{overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '12.5rem'}}
            title={props.label.length > 30 ? props.label: ''}
        >{props.label}</label>
      </components.Option>
    </div>
  );
};

const MultiValue = props => (
  props.data.value !== '*' &&
  <components.MultiValue {...props}>
    <span>{props.data.label}</span>
  </components.MultiValue>
);

const IndicatorsContainer = (selectProps) => {
  const selectedCount = selectProps.getValue().filter(option => option.value !== '*').length;

  return (
    <components.IndicatorsContainer {...selectProps}>
      { selectedCount > 0 && (<span className='select-container__selected_count'>{selectedCount}</span>) }
      <components.ClearIndicator {...selectProps} />
    </components.IndicatorsContainer>
  );
}

const animatedComponents = makeAnimated();

const RegionsCountriesSelect = (props) => {
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [regions, setRegions] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState([]);
  const [countries, setCountries] = useState([]);

  const firstLoadCountries = useRef(true);

  const addRegion = useRef(false);
  const removeRegion = useRef(false);

  useEffect(() => {
    if (props.regions_selected_options !== null && props.regions_selected_options !== undefined) {
      axios.get(props.regions_collection_url).then((response) => {
        const loadedOptions = response.data.data.map((item) => {
          return {value: item.id, label: item.name}
        });
        const selectedOptions = props.regions_selected_options
            ?
            props.regions_selected_options.map((selected_option) => {
              return loadedOptions.find((option) => {
                return option.value !== null && option.value !== undefined && option.value.toString() === selected_option.toString()
              })
            }).filter((option) => {
              return option !== null && option !== undefined;
            })
            :
            [];

        setRegions(loadedOptions);
        setSelectedRegion(selectedOptions);
      });
    }
  }, []);

  useEffect(() => {
    if (selectedRegion.length === 0) {
      setSelectedCountry([]);
    }

    if (selectedRegion.length > 0) {
      axios.get(props.countries_collection_url + '?scope=' + selectedRegion.map(region => region.value).join('@')).then((response) => {
        const loadedOptions = response.data.data.map((item) => {
          return {value: item.id, label: item.name}
        });

        if (props.countries_selected_options !== null && props.countries_selected_options !== undefined && props.countries_selected_options.length > 0 && firstLoadCountries.current) {
          const selectedOptions = props.countries_selected_options
              ?
              props.countries_selected_options.map((selected_option) => {
                return loadedOptions.find((option) => {
                  return option.value !== null && option.value !== undefined && option.value.toString() === selected_option.toString()
                })
              }).filter((option) => {
                return option !== null && option !== undefined;
              })
              :
              [];

          setSelectedCountry(selectedOptions);
        } else {
          let selectedOptions = selectedCountry.map((selected_option) => {
            return loadedOptions.find((option) => {
              return option.value !== null && option.value !== undefined && option.value.toString() === selected_option.value.toString()
            })
          }).filter((option) => {
            return option !== null && option !== undefined;
          });

          if (selectedOptions.length === 0) {
            selectedOptions = loadedOptions;
          } else {
            const newCountries = loadedOptions.filter(country => !countries.includes(country));
            selectedOptions = [...new Set([...selectedOptions, ...newCountries])]; // add new countries to selected
          }

          setSelectedCountry(selectedOptions);
        }

        setCountries(loadedOptions);

        firstLoadCountries.current = false;
      });

    }
  }, [selectedRegion]);

  const onRegionChange = selected => {
    setSelectedRegion(selected);
  };

  const onCountryChange = selected => {
    setSelectedCountry(selected);
  };

  return (
   <>
     <div>
       <label className="form__label">Regions</label>
       <SelectExtended
         value={selectedRegion}
         isMulti={true}
         styles={styles}
         isClearable={true}
         name='regions'
         className={`custom-multi-select ${props.class_name}`}
         classNamePrefix="select"
         onChange={onRegionChange}
         components={{Option, IndicatorsContainer, MultiValue, animatedComponents}}
         options={regions}
         closeMenuOnSelect={false}
         hideSelectedOptions={false}
         placeholder={null}
         allowSelectAll={true}
         isSearchable={true}
       />
     </div>

     <div style={{marginTop: '1.8rem'}}>
       <label className="form__label">Countries</label>
       <SelectExtended
         value={selectedCountry}
         isDisabled={selectedRegion.length === 0}
         isMulti={true}
         styles={styles}
         isClearable={true}
         name={props.name}
         className={`custom-multi-select ${props.class_name}`}
         classNamePrefix="select"
         onChange={onCountryChange}
         components={{Option, IndicatorsContainer, MultiValue, animatedComponents}}
         options={countries}
         closeMenuOnSelect={false}
         hideSelectedOptions={false}
         placeholder={null}
         allowSelectAll={true}
         isSearchable={true}
       />
     </div>
   </>
  )
};

RegionsCountriesSelect.propTypes = {
  regions_collection_url: T.string,
  regions_selected_options: T.array,

  countries_collection_url: T.string,
  countries_selected_options: T.array,

  multi: T.bool,
  async: T.bool,
  search: T.bool,
  label: T.string,
  name: T.string,
  class_name: T.string,
};

export default RegionsCountriesSelect;
